
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/code-history-empty-view.hbs';
    
    var globalCh = Radio.channel('global');

    var CodeHistoryEmptyView = Marionette.View.extend({
        tagName: 'tr',
        ui: {
            link: 'a',
        },
        initialize: function() {
            this.is_development = true;
            if (this.getOption('devicegroup').type === 'production_devicegroup' || this.getOption('devicegroup').type === 'factoryfixture_devicegroup') {
                this.is_development = false;
            }
        },
        events: {
            'click @ui.link': function (e) {
                e.preventDefault();
                if (this.is_development) {
                    globalCh.request('showCodeEditor', this.getOption('devicegroup').draft, this.getOption('devicegroup'));
                } else {
                    globalCh.request('showCreateDeployment', this.getOption('devicegroup'));
                }
            }
        },
        template: Handlebars.compile(template),
        templateContext: function () {
            return {
                num_cols: this.options.num_cols || 1,
            };
        },
    });

    export default CodeHistoryEmptyView;

